export default class Model {
  constructor(json) {
    for (let key in json) {
      this[key] = json[key];
    }
  }
}
